import { prop } from '@ipfabric/utils/fp/prop';
import { Button } from 'components/Button/Button';
import type { FC } from 'react';
import { useMultiplesGeneratorContextSelectors } from '../model/MultiplesGeneratorModel';
import { generateMultiplier } from '../model/commands/generateMultiplier';
import { generateMultiplierWithDelay } from '../model/commands/generateMultiplierWithDelay';

export const RegenerateControls: FC = () => {
  const ctxProps = useMultiplesGeneratorContextSelectors({
    dispatch: prop('dispatch'),
  });
  return (
    <p>
      <Button
        variant='secondary'
        onClick={() => {
          ctxProps.dispatch(generateMultiplier);
        }}
        type='button'
      >
        Generate another
      </Button>
      <Button
        variant='secondary'
        onClick={() => {
          ctxProps.dispatch(generateMultiplierWithDelay);
        }}
        type='button'
      >
        Generate with default delay
      </Button>
      <Button
        variant='secondary'
        onClick={() => {
          ctxProps.dispatch(generateMultiplierWithDelay, { timeout: 2000 });
        }}
        type='button'
      >
        Generate with 2s delay
      </Button>
    </p>
  );
};
